import React from "react";
import { CommonProps } from "@utils/interface";
import { useOnload } from "@utils/useRunOnload";
import { GSTCut, PlansTopBannerHeading, PlansTopBannerNudge, PlansTopBannerSubHeading, PlansTopBannerWrapper, Price, SelectPlanButton, StrikeThroughPrice } from "./styles";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
interface PlansTopBannerInterface extends CommonProps {
    topNudge: string;
    plansTitle: string;
    plansSubTitle?: string;
    price: string;
    gstCut?: string;
    strikeThroughPrice?: string;
    selectPlanButtonText?: string;
    styles?: any;
    showDealership?: boolean;
    dealership?: string;
    theme?: string;
    topBannerIamge?:string
}

const PlansTopBanner = ({ children, ...props }: PlansTopBannerInterface) => {
    const { actions, id } = props;
    const { on_load, on_click } = actions || {};
    const { topNudge, plansTitle, plansSubTitle, price, gstCut, strikeThroughPrice, selectPlanButtonText, styles, showDealership, dealership, theme = "light", topBannerIamge ="/images/zeroDepPlus.svg"} = props

    useOnload({ id, on_load });

    const onSelectPlan = () => {
        if (on_click?.length > 0) {
            on_click?.forEach((eachFunc: any) => {
                typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall({
                        ...eachFunc.args,
                    });
            });
        }
    }

    const ShowTopNudge = () => {
        return <PlansTopBannerNudge
            isVariant1={id === 'plans_top_banner1'}
            isVariant2={id === 'plans_top_banner2'}
            isVariant3={id === 'plans_top_banner3'}>
            {topNudge}</PlansTopBannerNudge>
    }


    return (
        <PlansTopBannerWrapper {...styles}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "8px", justifyContent: "space-between", paddingTop: "24px" }}>

                <div>
                    <PlansTopBannerHeading theme={theme}>{plansTitle}</PlansTopBannerHeading>
                    <PlansTopBannerSubHeading theme={theme}>{plansSubTitle}</PlansTopBannerSubHeading>
                </div>
                <ImageContainer
                    imgSrc={resolvePath(topBannerIamge)}
                    width={60}
                    height={52}
                    alt={"planimage"}
                />
            </div>

            <Flex
                flexDirection="row"
                alignItems="flex-start"
                justifyContent="space-between"
                style={{ marginTop: "24px" }}
            >
                <Flex
                    flexDirection="col"
                    alignItems="start"
                    justifyContent="start"
                    width="fit-content"
                >
                    <Flex
                        flexDirection="column"
                    >
                        <Flex flexDirection="row"
                            alignItems="end"
                            justifyContent="start">
                            <Price theme={theme}>{price}</Price>
                            {/* {strikeThroughPrice ? <StrikeThroughPrice>
                                {strikeThroughPrice}
                            </StrikeThroughPrice> : null} */}
                        </Flex>
                        {gstCut && <GSTCut theme={theme}>{gstCut}</GSTCut>}
                    </Flex>
                </Flex>
                <div>
                    <SelectPlanButton onClick={onSelectPlan}>
                        {selectPlanButtonText}
                    </SelectPlanButton>
                </div>
            </Flex>
        </PlansTopBannerWrapper>

    );
};

export default PlansTopBanner;
